export default __webpack_public_path__ + "static/media/Banner_image_Ruimte.cef288f5.jpg";